import { c as _c } from "react/compiler-runtime";
export default function NowMintingCountdownLoading() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="tw-relative tw-overflow-hidden tw-rounded-lg tw-border tw-border-solid tw-border-white/5 tw-bg-iron-900/60 tw-p-3 tw-text-left md:tw-p-4"><div className="tw-mb-2"><div className="tw-h-4 tw-w-24 tw-animate-pulse tw-rounded tw-bg-iron-700/70" /></div><div className="tw-h-14 tw-w-full tw-animate-pulse tw-rounded-md tw-bg-iron-700/70" /><div className="tw-mt-3 tw-h-10 tw-w-full tw-animate-pulse tw-rounded-lg tw-bg-iron-700/70" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}